import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import styled from "styled-components";
import leftArrow from "../assets/bi_arrow-left.svg";
import productsCocer1 from "../assets/productsCocer1.svg";

const ProductCoverd = () => {
  return (
    <Wrapper>
      <div className="product__section1">
        <Container>
          <Row>
            <Col xs={12} lg={4} md={12}>
              <div className="product__left">
                <h1>Small or big – we’ve got you covered.</h1>

                <p>
                  Forgot important files at your home and need them delivered
                  right to your office? Or need move items; small or big, we’ve
                  got you covered.
                </p>

                <button>
                  Learn More
                  <img src={leftArrow} alt="" />
                </button>
              </div>
            </Col>

            <Col md={12} lg={8} xs={12}>
              <div className="product__right">
                <img src={productsCocer1} alt="img" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .product__left {
    margin-top: 130px;
    h1 {
      font-family: Gilroy-Heavy;
      font-size: 40px;
      line-height: 46px;
      color: #6300ff;
      width: 420px;
      height: 92px;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #777e91;
      width: 445px;
      height: 83px;
      margin-top: 40px;
      letter-spacing: 0.6px;
    }
  }

  .product__left {
    margin-top: 158px;

    button {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 14px !important;
      line-height: 19px !important;
      color: #1292ee;
      width: 150px;
      height: 52px;
      border: none;
      outline: none;
      border-radius: 5px;
      position: relative;
      background: transparent;
      margin-top: 40px;
    }

    button::before {
      content: "";
      width: 50%;
      height: 100%;
      background: rgba(18, 146, 238, 0.1);
      left: 0;
      top: 0;
      position: absolute;
      border-radius: 5px;
      transition: 0.4s all;
    }

    button:hover::before {
      width: 100%;
      border-radius: 5px;
    }
    button img {
      margin-left: 12px;
    }
  }

  .product__right {
    margin-left: 30px;
    width: 744px;
    height: 712px;
    img {
      width: 100%;
      height: 100%;
      /* margin-left: 45px; */
    }
  }

  .product__section1 {
    background: #e5edfc;
    margin-top: 50px;
    padding-top: 82px;

    h1 {
      font-family: Gilroy-Heavy;
      font-size: 40px;
      line-height: 46px;
      color: #6300ff;
      width: 420px;
      height: 92px;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #545777;
      width: 445px;
      height: 82px;
      margin-top: 22px;
    }
    h6 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 18px;
      line-height: 22px;
      color: #1292ee;
      width: 130px;
      height: 25px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  @media screen and (max-width: 440px) {
    .product__section1 {
      padding-bottom: 70px;
      padding-top: 80px;
    }

    .product__left {
      margin-top: 158px;
      h1 {
        font-family: Gilroy-Heavy !important;
        font-size: 30px !important;
        line-height: 46px !important;
        color: #6300ff !important;
        width: 100% !important;
        height: 92px !important;
        padding-left: 20px;
      }
      p {
        font-family: "Manrope" !important;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 28px !important;
        color: #777e91;
        width: 100%;
        height: auto;
        margin-top: 40px;
        padding-left: 20px;
        -webkit-letter-spacing: 0.6px;
        -moz-letter-spacing: 0.6px;
        -ms-letter-spacing: 0.6px;
        letter-spacing: 0.6px;
      }

      button {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 14px !important;
        line-height: 19px !important;
        color: #1292ee;
        width: 150px;
        height: 52px;
        border: none;
        outline: none;
        border-radius: 5px;
        position: relative;
        background: transparent;
        margin-top: 40px;
        margin-left: 20px;
      }

      button::before {
        content: "";
        width: 50%;
        height: 100%;
        background: rgba(18, 146, 238, 0.1);
        left: 0;
        top: 0;
        position: absolute;
        border-radius: 5px;
        transition: 0.4s all;
      }

      button:hover::before {
        width: 100%;
        border-radius: 5px;
      }
      button img {
        margin-left: 12px;
      }
    }

    .product__right {
      margin-left: 30px;
      width: 442px;
      height: 470px;
      img {
        width: 100%;
        height: 100%;
        margin-left: 45px;
      }
    }

    .product__left {
    }
  }

  @media screen and (max-width: 414px) {
    .product__section1 {
      padding-bottom: 70px;
      padding-top: 80px;
    }

    .product__left {
      margin-top: 158px;
      h1 {
        font-family: Gilroy-Heavy !important;
        font-size: 30px !important;
        line-height: 46px !important;
        color: #6300ff !important;
        width: 100% !important;
        height: 92px !important;
        padding-left: 20px;
      }
      p {
        font-family: "Manrope" !important;
        font-style: normal !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 28px !important;
        color: #777e91;
        width: 100%;
        height: auto;
        margin-top: 40px;
        padding-left: 20px;
        -webkit-letter-spacing: 0.6px;
        -moz-letter-spacing: 0.6px;
        -ms-letter-spacing: 0.6px;
        letter-spacing: 0.6px;
      }

      button {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 14px !important;
        line-height: 19px !important;
        color: #1292ee;
        width: 150px;
        height: 52px;
        border: none;
        outline: none;
        border-radius: 5px;
        position: relative;
        background: transparent;
        margin-top: 40px;
        margin-left: 20px;
      }

      button::before {
        content: "";
        width: 50%;
        height: 100%;
        background: rgba(18, 146, 238, 0.1);
        left: 0;
        top: 0;
        position: absolute;
        border-radius: 5px;
        transition: 0.4s all;
      }

      button:hover::before {
        width: 100%;
        border-radius: 5px;
      }
      button img {
        margin-left: 12px;
      }
    }

    .product__right {
      margin-left: 30px;
      width: 442px;
      height: 470px;
      img {
        width: 100%;
        height: 100%;
        margin-left: 45px;
      }
    }

    .product__left {
    }
  }

  @media screen and (max-width: 768px) {
    .product__right {
      margin-left: 0px !important;
      width: 100%;
      padding: 100px 0;
      img {
        width: 100% !important;
        height: auto !important;
        margin-left: 0px !important;
      }
    }

    .product__left {
      margin-top: 0;
      margin-left: 0;
      width: 100% !important;
      h1 {
        font-family: Gilroy-Heavy;
        font-size: 36px;
        line-height: 46px;
        color: #6300ff;
        width: 100%;
        height: 92px;
      }
      p {
        font-family: "Manrope";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        color: #545777;
        width: 100%;
        height: auto;
        margin-top: 26.68px;
      }
      button {
        font-family: Gilroy;
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 22px;
        color: #1292ee;
        width: 50%;
        padding-left: 12px;
        height: 40px;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        justify-content: flex-start;
      }
    }
  }
`;

export default ProductCoverd;
